export function asArray<T>(input: Array<T> | T): Array<T> {
  return new Array<T>().concat(input || []);
}
